module.exports = __webpack_public_path__ + "static/media/experience.7d0b0903.svg";